import { actorsAPI, brokersAPI } from "services/swagger-api";
import { PersonTypeEnum, SearchInsuredCommandDto, SortingFieldEnum } from "api/actor";
import { DEFAULT_PAGE_SIZE } from "./constants";
import { SearchFeatureFilter } from "./types";

const getSearchPersonType = (withNaturalPerson: boolean, withLegalEntity: boolean): PersonTypeEnum => {
  if (withNaturalPerson && withLegalEntity) return PersonTypeEnum.All;
  if (withNaturalPerson) return PersonTypeEnum.NaturalPerson;
  if (withLegalEntity) return PersonTypeEnum.LegalEntity;
  return PersonTypeEnum.All;
};

export type SearchFunction = (query: string, params: {
  withNaturalPerson: boolean;
  withLegalEntity: boolean;
  plateformeId?: string;
}) => Promise<{ items: any[]; totalCount: number } | null>;

export const createSearchFunctions = (): Record<SearchFeatureFilter, SearchFunction> => ({
  [SearchFeatureFilter.Default]: async (query, { withNaturalPerson, withLegalEntity, plateformeId }) => {
    const searchInsuredCommandDto: SearchInsuredCommandDto = {
      searchString: query.trim(),
      personType: getSearchPersonType(withNaturalPerson, withLegalEntity),
      pageNumber: 1,
      pageSize: DEFAULT_PAGE_SIZE,
      sorting: SortingFieldEnum.CreationTimeDesc,
      plateformeId
    };

    return await actorsAPI.searchInsured({ searchInsuredCommandDto });
  },

  [SearchFeatureFilter.Broker]: async (query, { withNaturalPerson, withLegalEntity }) => {
    const getGenericListCommandDto = {
      searchString: query.trim(),
      personType: getSearchPersonType(withNaturalPerson, withLegalEntity),
      pageNumber: 1,
      pageSize: DEFAULT_PAGE_SIZE,
      isActiveBroker: true,
    };

    return await brokersAPI.getBrokers({ getGenericListCommandDto });
  },

  [SearchFeatureFilter.LeadBroker]: async (query) => {
    const getGenericListCommandDto = {
      searchString: query.trim(),
      pageNumber: 1,
      pageSize: DEFAULT_PAGE_SIZE
    };

    return await brokersAPI.getBrokersPlateforme({ getGenericListCommandDto });
  }
});
